import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import {reduxForm} from "redux-form";
import { DateField , DatePicker} from 'react-date-picker'
import 'react-date-picker/index.css'
import MaskedInput from "react-maskedinput";
var date = require('date-and-time');
import _ from 'lodash';
import {AddChatPerson, EditChatPerson, getOneSpecialEvents, deleteSpecialEvents, GetChatPerson, GetForingLang, addSpecialEvents, editSpecialEvents, getSpecialStats} from '../../actions/index';

import { connect } from 'react-redux';

class ChatSpecialAdd extends Component {
    static contextTypes = {
        router: PropTypes.object,
        fields: PropTypes.object
    };
    constructor(props){
        super(props);
        this.state = {
            img: '',
            person: false
        }
        this.delChatPersonOpenModal = this.delChatPersonOpenModal.bind(this);
        this.delChatPerson = this.delChatPerson.bind(this);
        this.renderPersons = this.renderPersons.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.save = this.save.bind(this);
        this.calendars = this.calendars.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.calendar = this.calendar.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetChatPerson(token);
        this.props.GetForingLang(token);
        if(this.props.params.id){
            this.props.getOneSpecialEvents(this.props.params.id, token)
        }
    }
    componentDidMount(){
        let that = this;
        $('.timepicker').timepicker({
            defaultTime: false,
            minuteStep: 5,
            snapToStep: true
        }).on('hide.timepicker', function(e) {
            that.props.fields[e.target.name].onChange(e.time.value)
        });

        $('.datapickers').datepicker({
            language: 'en',
            format: "dd.mm.yyyy",
            autoclose: true
        }).on('hide', function(e){
            let  dateObject = $(this).val();
            that.props.fields[e.target.name].onChange(dateObject);
            $(this).datepicker('hide');
        });
    }
    componentWillUnmount(){
        this.props.chat.special_event_one = {}
    }
    delChatPerson(){
        let token = localStorage.getItem('id_token_admin');
        this.props.deleteSpecialEvents(this.props.chat.special_event_one.id, token).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal();
                this.props.getSpecialStats(token);
                this.context.router.push('/chat/special');
            }
        });
    }

    edit(e){
        let block = $(e.target).data('id')
        $('#'+block+' .idetBlock').summernote({
            lang: "ru-RU",
            height: 150,
            dialogsInBody: true,
            toolbar: [
                ["font", ["bold", "underline", "clear"]],
                ['fontsize', ['fontsize']],
                ['color', ['color']],
                ["para", ["ul", "ol", "paragraph"]],
                ["table", ["table"]],
                ["insert", ["link", "picture", "video"]],
                ["view", ["fullscreen", "codeview"]]
            ]
        });
        $('#'+block+' .btn-primary').show();
    };
    save(e){
        let block = $(e.target).data('id')
        let makrup = $('#'+block+' .idetBlock').summernote('code');
        $('#'+block+' .idetBlock').summernote('destroy');
        $('#'+block+' .btn-primary').hide();
        $('#'+block+' .idetBlock').closest('.addWordBlock').removeClass('has-error');
    };
    delChatPersonOpenModal(id, item){
        let token = localStorage.getItem('id_token_admin');
        let that = this;
        $('#DelChatPerson').modal('show');
    }
    closeModal(){
        $('#DelChatPerson').modal('hide');
    }
    SubmitForm(props){
        let token = localStorage.getItem('id_token_admin');
        let arr = [];
        props.date_from = props.date_from.replace('PM', 'p.m.');
        props.date_from = props.date_from.replace('AM', 'a.m.');
        props.date_to = props.date_to.replace('PM', 'p.m.');
        props.date_to = props.date_to.replace('AM', 'a.m.');
        props.date_from = date.parse(props.date_from, 'DD.MM.YYYY hh:mm A');
        props.date_to = date.parse(props.date_to, 'DD.MM.YYYY hh:mm A');

        for(let i=0; i<$('.addWordBlock').length; i++){
            let oneBlock = $('.addWordBlock')[i];
            if($(oneBlock).find('.idetBlock').html() != '' && $(oneBlock).find('.idetBlock').html() != '<p><br></p>'){
                let obj = {
                    flang: $(oneBlock).find('#edit').data('name'),
                    text: $(oneBlock).find('.idetBlock').html()
                };
                arr.push(obj);
            }else{
                let obj = {
                    flang: $(oneBlock).find('#edit').data('name'),
                    text: '<p><br></p>'
                };
                arr.push(obj);
            }
            // else{
            //     $(oneBlock).addClass('has-error');
            // }
        }
        if($('.form_chat_events').find('.has-error').length > 0){
            return false;
        }else{
            props.translations = arr;
            if(this.props.params.id){
                this.props.editSpecialEvents(token, props, this.props.params.id).then((response)=>{
                    if(response.payload.status == '200'){
                        this.context.router.push('/chat/special');
                    }
                })
            } else {
                this.props.addSpecialEvents(token, props).then((response)=>{
                    if(response.payload.status == '201'){
                        this.context.router.push('/chat/special');
                    }
                })
            }

        }

    }
    handleChange(e){
        this.setState({
            [e.target.name]: e.target.value
        });
        this.props.fields[e.target.name].onChange(parseInt(e.target.value));
    }
    renderPersons(){
        return this.props.chat.personsList.results.map((item, i)=>{
            return(
                <div className="col-md-6" key={item.id}>
                    <input type="radio" name="person" value={item.id} id={'person'+item.id} checked={item.id == this.state.person} onChange={this.handleChange}/>
                    <label htmlFor={'person'+item.id}>{item.name}</label>
                </div>
            )
        })
    }
    renderTranslateBlock(id, name){
        if(this.props.params.id){
            let item = _.findWhere(this.props.chat.special_event_one.translations, {flang: id});
            if(_.findWhere(this.props.chat.special_event_one.translations, {flang: id})){
                return(
                    <div className="col-md-4">
                        <div className="idetBlock" dangerouslySetInnerHTML={{__html: item.text}}></div>
                        <div className="blockBtn">
                            <button id="edit" data-name={id} data-id={name} className="btn btn-default" onClick={this.edit} type="button">Edit</button>
                            <button id="save" data-name={id} data-id={name} className="btn btn-primary" onClick={this.save} type="button">Save</button>
                        </div>
                    </div>
                )
            }else{
                return(
                    <div className="col-md-4">
                        <div className="idetBlock" dangerouslySetInnerHTML={{__html: ''}}></div>
                        <div className="blockBtn">
                            <button id="edit" data-name={id} data-id={name} className="btn btn-default" onClick={this.edit} type="button">Edit</button>
                            <button id="save" data-name={id} data-id={name} className="btn btn-primary" onClick={this.save} type="button">Save</button>
                        </div>
                    </div>
                )
            }
        }else{
            return(
                <div className="col-md-4">
                    <div className="idetBlock" dangerouslySetInnerHTML={{__html: ''}}></div>
                    <div className="blockBtn">
                        <button id="edit" data-name={id} data-id={name} className="btn btn-default" onClick={this.edit} type="button">Edit</button>
                        <button id="save" data-name={id} data-id={name} className="btn btn-primary" onClick={this.save} type="button">Save</button>
                    </div>
                </div>
            )
        }
    }
    renderTranslate(){
        return this.props.lang.foring_lang.results.map((item)=>{
            return(
                <div className='clearfix addWordBlock' key={item.id} id={item.lang.name}>
                    <div className="col-md-4">
                        <label htmlFor="">{item.lang.name}</label>
                    </div>
                    {this.renderTranslateBlock(item.id, item.lang.name)}

                </div>
            )
        });
    }
    calendars(e, item){
        this.props.fields[item].onChange(e);
    }
    uploadState(){
        this.setState({
            person: this.props.chat.special_event_one.person
        })
    }
    calendar(e, value){
        if(value == ''){
            return false
        }else{
            this.props.fields[e].onChange(value);
        }

    }
    render() {
        const { fields: {
            event_name,
            date_from,
            time_from,
            date_to,
            time_to,
            person}, handleSubmit} = this.props;
        if(this.state.person == false && this.props.chat.special_event_one.person){
            this.uploadState();
            this.props.fields.person.onChange(this.props.chat.special_event_one.person);
        }
        return (
            <div className="dashboard-wrapper">
                {this.props.params.id ? <p className="dashboard-title">{this.props.chat.special_event_one.event_name} </p> : <p className="dashboard-title">Add chat box</p>}
                <p className="dashboard-text">Chat</p>
                <form className="form_chat_events" onSubmit={handleSubmit(this.SubmitForm.bind(this))}>
                    <div className="col-md-12">
                        <div className="white-block block-4-8 clearfix">
                            <div className='clearfix'>
                                <div className="col-md-4">
                                    <label htmlFor="name">Name Event</label>
                                </div>
                                <div className={ event_name.touched && !event_name.valid ? 'col-md-4 has-error' : 'col-md-4'}>
                                    <input type="text"
                                           placeholder="Name"
                                           className="form-control"
                                           name="event_name"
                                           id="event_name"
                                           {...event_name}
                                    />
                                </div>
                            </div>
                            <div className='clearfix'>
                                <div className="col-md-4">
                                    <label htmlFor="">Select Person</label>
                                </div>
                                <div className={ person.touched && !person.valid ? 'col-md-4 has-error-block' : 'col-md-4'}>
                                    <div className="row">
                                        {this.props.chat.personsList.results ? this.renderPersons() : ""}
                                    </div>
                                </div>
                            </div>
                            <div className="border">
                                <div className='clearfix'>
                                    <div className="col-md-4">
                                        <label htmlFor="">Start date</label>
                                    </div>
                                    <div className={ date_from.touched && !date_from.valid ? 'col-md-4 has-error date_times' : 'col-md-4 date_times'}>
                                        <DateField
                                            dateFormat="DD.MM.YYYY hh:mm A"
                                            value={date_from.value}
                                            name="date_from"
                                            onChange={this.calendar.bind(this, 'date_from')}
                                        >
                                            <DatePicker
                                                navigation={true}
                                                locale="en"
                                                forceValidDate={true}
                                                highlightWeekends={true}
                                                highlightToday={true}
                                                weekNumbers={true}
                                                weekStartDay={1}
                                                footer={true}
                                            />
                                        </DateField>
                                    </div>
                                </div>

                            </div>
                            <div className='clearfix'>
                                <div className="col-md-4">
                                    <label htmlFor="">Expiry date</label>
                                </div>
                                <div className={ date_to.touched && !date_to.valid ? 'col-md-4 has-error date_times' : 'col-md-4 date_times'}>
                                    <DateField
                                        value={date_to.value}
                                        name="date_to"
                                        dateFormat="DD.MM.YYYY hh:mm A"
                                        onChange={this.calendar.bind(this, 'date_to')}
                                    >
                                        <DatePicker
                                            navigation={true}
                                            locale="en"
                                            forceValidDate={true}
                                            highlightWeekends={true}
                                            highlightToday={true}
                                            weekNumbers={true}
                                            weekStartDay={1}
                                            footer={true}
                                        />
                                    </DateField>
                                </div>
                            </div>

                            <div className="border">
                                {this.props.lang.foring_lang.results && this.props.lang.foring_lang.results.length > 0 ? this.renderTranslate() : ""}
                            </div>

                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="white-block clearfix">
                            <div className="col-md-12 text-center button-group">
                                <Link to={"chat/special"} className="btn btn-default">Back</Link>
                                {this.props.params.id ? <button  onClick={this.delChatPersonOpenModal} type="button" className="btn btn-danger">Delete</button> : ""}
                                <button type="submit" className="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </form>

                <div className="modal fade" id="DelChatPerson" tabIndex="-1" role="dialog" aria-labelledby="DelChatPersonLabel">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body text-center">
                                <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#DelAdmin"></span>
                                <p>Do you really want to delete chat event {this.props.chat.special_event_one ? <span>{this.props.chat.special_event_one.event_name} </span> : ""}?</p>
                            </div>
                            <div className="modal-footer text-center">
                                <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                <button onClick={this.delChatPerson} type="button" className="btn btn-primary">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>

        );
    }
}


function validate(values) {
    const errors = {};
    if(!values.event_name){
        errors.event_name = 'Enter a name'
    }
    if(!values.date_from || values.date_from == 'aN.aN.0NaN 12:aN a.m.' || values.date_from == ''){
        errors.date_from = 'Enter date_from'
    }
    if(!values.date_to || values.date_to == 'aN.aN.0NaN 12:aN a.m.' ||  values.date_to == ''){
        errors.date_to = 'Enter date_from'
    }
    if(!values.person){
        errors.person = 'time_from'
    }
    return errors;
}

function  mapStateToProps(state) {
    return{
        chat: state.chat,
        lang: state.lang,
        initialValues :{
            event_name : state.chat.special_event_one.event_name || '',
            date_from: state.chat.special_event_one.date_from ? date.format(new Date(state.chat.special_event_one.date_from), 'DD.MM.YYYY hh:mm A') : '',
            date_to: state.chat.special_event_one.date_to ? date.format(new Date(state.chat.special_event_one.date_to), 'DD.MM.YYYY hh:mm A') : ''
        }
    }
}

export default reduxForm({
    form: 'Edit Person',
    fields: ['event_name', 'date_from', 'date_to', 'time_to', 'time_from', 'person'],
    validate
}, mapStateToProps, {AddChatPerson, EditChatPerson, getOneSpecialEvents, deleteSpecialEvents, GetChatPerson, GetForingLang, addSpecialEvents, editSpecialEvents, getSpecialStats})(ChatSpecialAdd);



// WEBPACK FOOTER //
// ./src/components/chat/chatSpecialAdd.js